export const COPY_TOOLTIP_DURATION_MS = 3000;
